import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { INewsfeed } from "../models/newsfeed.model";

import { IApplicants, IOfferLetter } from "../models/applicants-list.model";
import { BuildEnvironment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ApplicantsListService {
  private baseurl: string;

  constructor(private http: HttpClient) {
    let rootURL = BuildEnvironment.GetEnvironmentUrl();
    //let rootURL = BuildEnvironment.GetEnvironmentUrl();
    this.baseurl = rootURL;
  }

  getAllApplicantsList(): Observable<IApplicants[]> {
    return this.http.get<IApplicants[]>(
      this.baseurl + "/peopleSoft/applicants-list"
    );
    //return this.http.get(this.baseurl + "/newsfeeds",{observe: 'response'});
  }

  getOfferLetterPdf(
    studentNumber: any,
    applicationNumber: any,
    ApplProgNbr: any
  ): Observable<IOfferLetter[]> {
    return this.http.post<IOfferLetter[]>(
      this.baseurl + "/peopleSoft/offer-letter",
      {
        emplid: studentNumber,
        admApplNbr: applicationNumber,
        aplProgNbr: ApplProgNbr,
      }
    );
  }

  getNewsfeedById(newsfeedid: number): Observable<INewsfeed> {
    try {
      return this.http.get<INewsfeed>(
        this.baseurl + "/newsfeeds/" + newsfeedid
      );
    } catch (err) {
      console.log("---------Unexpected error occured-------");
      return this.handleError(err as HttpErrorResponse);
    }
  }

  insertNewsfeed(formdata: any) {
    try {
      return this.http.post(this.baseurl + "/newsfeeds/insert", formdata);
    } catch (err) {
      console.log("-------Error occurred posting----" + err);
      console.log("---------Unexpected error occured-------");
      return this.handleError(err as HttpErrorResponse);
    }
  }
  updateNewsfeed(formdata: any, newsfeedid: string) {
    try {
      return this.http.post(
        this.baseurl + "/newsfeeds/update/" + newsfeedid,
        formdata
      );
    } catch (err) {
      console.log("---------Unexpected error occured-------");
      return this.handleError(err as HttpErrorResponse);
    }
  }
  deleteNewsfeed(newsfeedid: string) {
    return this.http.delete(this.baseurl + "/newsfeeds/" + newsfeedid, {
      headers: {},
      params: { newsfeedid: newsfeedid },
    });
  }

  private handleError(err: HttpErrorResponse) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage = "";
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}
